export const BASESCAN = {
  BASE_URL: 'https://basescan.org',
  TX_URL: 'https://basescan.org/tx/',
  ADDRESS_URL: 'https://basescan.org/address/',
} as const

export function getBasescanAddressUrl(address: string): string {
  return `${BASESCAN.ADDRESS_URL}${address}`
}
